export const getAddressTokenBalanceByContract = async (contract, accountAddress, tokenId) => {
    try {
        let tokenBalance;
        if (tokenId) {
            // ERC1155 or multi-token contract - balanceOf(address, tokenId)
            tokenBalance = await contract.balanceOf(accountAddress, tokenId);
        }
        else {
            // ERC20 or ERC721 contract - balanceOf(address)
            tokenBalance = await contract.balanceOf(accountAddress);
        }
        // Convert bigint to number safely
        // Check if the bigint is within safe integer range
        if (tokenBalance > Number.MAX_SAFE_INTEGER) {
            throw new Error(`Token balance too large for safe conversion: ${tokenBalance}`);
        }
        const balanceNumber = Number(tokenBalance);
        return balanceNumber;
    }
    catch (error) {
        console.error('Error getting token balance:', error);
        throw new Error(`Failed to get token balance: ${error.message}`);
    }
};
